import { takeLatest, ForkEffect, takeEvery, throttle } from 'redux-saga/effects';
import { Action } from 'redux';
import { Methods } from '../constants/constants';
import { IDataInput } from '../interface/interfaces';
import workerSaga from './workerSaga';

function createFetchSaga<T, P extends IDataInput>(
    pendingAction: string,
    successAction: (data: T) => Action,
    failureAction: (error: string) => Action,
    method: Methods,
    isProtected = true,
    hasURLRoot = false,
    isChat = false,
): () => Generator<ForkEffect<never>, void, unknown> {
    return function* fetchSaga() {
        // yield takeEvery(pendingAction, function* (action: Action & { payload: P }) {
        yield takeEvery(pendingAction, function* (action: Action & { payload: P }) {
            yield workerSaga(action, successAction, failureAction, method, isProtected, hasURLRoot, isChat);
        });
    };
}

export default createFetchSaga;
